module.exports = __webpack_public_path__ + "static/media/service_system_5.286a8ae2.png";